module.exports = __webpack_public_path__ + "static/media/Akemi_6251.8ba66ca5.jpg";